module.exports = __webpack_public_path__ + "img/822006639.cdb4138b.png";